import { useEffect, useState } from "react";

export function useAnimatedLoadingMessage(isLoading: boolean, baseMessage: string = "Loading"): string {
  const [dotCount, setDotCount] = useState(0);

  // Animate 3 dots in a loop
  useEffect(() => {
    if (!isLoading) {
      setDotCount(0);
      return;
    }

    const interval = setInterval(() => {
      setDotCount(prev => (prev + 1) % 4);
    }, 330);

    return () => clearInterval(interval);
  }, [isLoading]);

  if (!isLoading) {
    return baseMessage;
  }

  const dots = ".".repeat(dotCount);
  return `${baseMessage}${dots}`;
}
